export const buildProductBaseUpdatePayload = ({ id, values, currentImage }) => {
  const { base64, ...productValues } = values;

  return {
    ...productValues,
    id,
    ...(base64 !== currentImage ? { base64 } : {})
  };
};
